// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"89d49eec","453":"74abc4f6","455":"dcfc9884","644":"0dac82e7"}[chunkId] + ".chunk.js";
};